import React, {Component} from 'react';

class Splash extends Component {

    componentDidMount() {

        this.props.history.push({
            pathname: '/login',
            state: {redirectUrl: this.props.location.pathname}
        });

        setTimeout(this.props.callbackRender, 1000);
    }

    render() {

        return (
            <div id="fuse-splash-screen">

                <div className="center">

                    <div className="logo">
                        <img width="128"
                             src="https://res.cloudinary.com/uecare/image/upload/v1524451999/official/appLogo_3x.png"
                             alt="logo"/>
                    </div>

                    <div className="spinner-wrapper">
                        <div className="spinner">
                            <div className="inner">
                                <div className="gap"/>
                                <div className="left">
                                    <div className="half-circle"/>
                                </div>
                                <div className="right">
                                    <div className="half-circle"/>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}


export default Splash;



// WEBPACK FOOTER //
// ./src/main/Splash.js